<template>
    <!-- Navbar dropdowns -->
    <b-nav-item-dropdown text="Programación" v-show="isOK == true" left>
            
            <b-dropdown-group id="dropdown-group-1" header="Spreadsheet">
                <b-dropdown-item href="https://docs.google.com/spreadsheets/d/1O3nDs8PqDduOca9uyw4Z7YDPw9KIkuUklvyAJ9SXbsg/edit#gid=376152194" target="blank">Programación drive</b-dropdown-item>
            </b-dropdown-group>
            
           
    </b-nav-item-dropdown>
</template>

<script>
    import {mapState,mapActions} from 'vuex'
    import customMixin from '@/mixins/customMixin'
    export default {
        mixins : [customMixin],
        data: function(){
            return {
                isOK: false
            }
        },
        mounted(){
            this.init()
        },
        computed:{
            ...mapState('login',['rol_id']),
            ...mapState('permiso',['permiso']),   
        },
        methods:{
            ...mapActions({
                _fetchPermisos: 'permiso/fetchPermisosUsuarios',
            }),
            init(){
                this._fetchPermisos(this.rol_id).then(() => {  
                    this.isOK =  this.isGoogle(this.permiso) 
                })
            },
        }//end methods         
    }
</script>

<style lang="scss" scoped>

</style>